// Cross-run progression (deepest main-path level reached), used for character unlocks.
// Same fail-silent localStorage pattern as hintStorage: unavailable storage means progress
// tracks within the session but doesn't persist.

import { isMainPathLevel } from "../engine/levelgenerator/prodLevelGenerator";

const STORAGE_KEY = "bullettime:progress";

export interface ProgressUpdate {
	previousMax: number;
	newMax: number;
}

export function loadMaxLevelReached(): number {
	try {
		if (typeof localStorage === "undefined") return 0;
		const raw = localStorage.getItem(STORAGE_KEY);
		if (raw === null) return 0;
		const parsed = JSON.parse(raw);
		return typeof parsed?.maxLevelReached === "number" ? parsed.maxLevelReached : 0;
	} catch {
		return 0;
	}
}

export function recordLevelReached(levelNumber: number): ProgressUpdate {
	const previousMax = loadMaxLevelReached();
	if (!isMainPathLevel(levelNumber) || levelNumber <= previousMax) {
		return { previousMax, newMax: previousMax };
	}
	try {
		if (typeof localStorage !== "undefined") {
			localStorage.setItem(STORAGE_KEY, JSON.stringify({ maxLevelReached: levelNumber }));
		}
	} catch {
		// ignore
	}
	return { previousMax, newMax: levelNumber };
}
